require('base-layout');
var pageType = require('dynamic-module-registry').get('getInfoOrEnroll').pageType;
var $ = require('lc-jquery');
var FormManager = require('ui-form-manager');
var Modal = require('ui-modal');

const enrichUserPropsWithLead = require('pf-onboarding-v2-ui/src/lib/enrichUserPropsWithLead').default;

var schema;
if (pageType === 'get-info') {
  schema = require('./schemas/get-info-schema');
} else {
  schema = require('./schemas/enroll-schema');
}

function GetInfoEnrollPage() {
  var self = this;
  self.$form = $('.pi1-form-container').find('form');
  self.registerModals();
  self.registerEvents(); // register our events before formManager's
  self.formManager = self.registerForm(self.$form);

  if (window.lcTracking && window.lcTracking.tracking) {
    const data = window.lcTracking.data || { userProps: {} };
    const trackingData = Object.assign(data, {});
    trackingData.userProps.PF_EREG_EXP = 'CONTROL';
    if (window.lcTracking.tracking && window.lcTracking.tracking.enrichEventsForUser) {
      window.lcTracking.tracking.enrichEventsForUser(trackingData.userProps);
    }
  }
}

GetInfoEnrollPage.prototype.registerEvents = function() {
  var self = this;

  // form submit events
  self.$form.submit(self.addSubmitType.bind(self));

  // Register change for enable disable of additional info
  $('select[name=howDidYouHear]').on('change', function(event) {
    event.preventDefault();
    enableDisableHowDidYouHearAddlInfo(event);
  });
};


GetInfoEnrollPage.prototype.registerModals = function() {
  var NImodal = new Modal($('#NI-details-modal'));
  var PRPmodal = new Modal($('#PRP-details-modal'));

  // modal events
  $('a[data-aid="detailsBtn1"]').on('click', function(event) {
    event.preventDefault();
    NImodal.show();
  });
  $('a[data-aid="detailsBtn3"]').on('click', function(event) {
    event.preventDefault();
    PRPmodal.show();
  });
  $('.details-modal-close').on('click', function() {
    NImodal.hide();
    PRPmodal.hide();
  });
};

GetInfoEnrollPage.prototype.registerForm = function(form) {
  var formManager = new FormManager(form, {
    endPoint: {
      url: '/patientsolutions/enroll/' + (pageType === 'get-info' ? 'get-info' : '')
    },
    schema: schema,
    submitControl: $('button[name=action]'),
    spinner: true,
    transformFunction: function(formFields) {
      for (var key in formFields) {
        if (formFields.hasOwnProperty(key) && typeof formFields[key] === 'string') {
          formFields[key] = formFields[key].trim();
        }
      }
      formFields.variation = 'CONTROL';
      return formFields;
    }
  });
  formManager.on('error', function() {
    location.href = '/patientsolutions/enroll/error';
  });
  formManager.on('success', function(data) {
    if (data.redirect) {
      enrichUserPropsWithLead(data.capId, 'CONTROL');
      location.href = data.redirect;
      return;
    }
    if (data.emailAlreadyUsedError) {
      formManager.markError($('[data-aid=email]'), 'An account for this email has already been created. Please <a href="/patientsolutions/login/">Login</a>');
    }
  });
  return formManager;
};

// Enable Disable How did you hear additional information
function enableDisableHowDidYouHearAddlInfo(event) {
  var addlInfoField = $('#howDidYouHearAdditionalInfo');
  var howDidYouHear = $('#howDidYouHear option:selected').text();

  if (howDidYouHear === 'Consultant, lab, vendor or lecture') {
    addlInfoField.removeClass('hidden');
    addlInfoField.attr('placeholder', 'Enter consultant, lab, vendor or lecture name');
  } else if (howDidYouHear === 'Meeting or tradeshow') {
    addlInfoField.removeClass('hidden');
    addlInfoField.attr('placeholder', 'Enter meeting or tradeshow name');
  } else {
    if (!addlInfoField.hasClass('hidden')) {
      addlInfoField.addClass('hidden');
      if (addlInfoField.hasClass('has-error')) {
        addlInfoField.removeClass('has-error');
      }
      var errorElement = addlInfoField.next('.error-message');
      if (errorElement && errorElement.first('.error-text').text().includes('consultant')) {
        errorElement.remove();
      }
    }
  }
}

// In order to play well with form manager, we must dynamically add a field for submitType
GetInfoEnrollPage.prototype.addSubmitType = function() {
  var self = this;
  var submitType = pageType; // default in case user sumbits form by pressing "Enter" key
  var clickedBtn = document.activeElement;
  if (clickedBtn.value === 'get-info' || clickedBtn.value === 'enroll') {
    submitType = clickedBtn.value;
  }
  $('input[name=submitType]').remove();
  self.$form.append($('<input>').attr({
    type: 'hidden',
    name: 'submitType',
    value: submitType
  }));

  self.$form.append($('<input>').attr({
    type: 'hidden',
    name: 'variation',
    value: 'CONTROL'
  }));
};

new GetInfoEnrollPage();

// The button for fill form is excluded from prod environment
var mockPI1Content = require('onboarding-utils').mockPI1Content();
$('#fill-me').click(function() {
  for (var prop in mockPI1Content) {
    $('input[name="' + prop + '"]').val(mockPI1Content[prop]);
  }
  $('select[name="specialty"]').prop('selectedIndex', 3);
  $('select[name="howDidYouHear"]').prop('selectedIndex', 3);
});

module.exports = {};

require('/var/lib/jenkins/workspace/pf-onboarding-ui_Release_0/src/node_modules/get-info-enroll/get-info-enroll.less');